const form = {
  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        '&.MuiFormControlLabel-dashed:has(.Mui-focusVisible, .MuiCheckbox-root:focus-visible)': {
          outline: '1px dashed #b51e1f',
          borderRadius: '3px',
          paddingRight: 9,
        },
      },
      labelPlacementEnd: {
        marginLeft: 0,
      },
    },
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        margin: '4px 0 0',
        fontSize: '0.75rem',
        lineHeight: 1.2,
      },
    },
  },
};
export default form;
